var map = {
	"./1.png": 148,
	"./2.png": 149,
	"./3.png": 150,
	"./4.png": 151,
	"./5.png": 152,
	"./6.png": 153,
	"./7.png": 154,
	"./8.png": 155,
	"./9.png": 156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;